import { Fragment } from "react/jsx-runtime";
import ColouredText from "./Blocks/ColouredText";
import ImageBlock from "./Blocks/ImageBlock";
import type { Article, BlockType, Media } from "./types";
import type { ReactNode } from "react";

interface Props {
    article: Article;
}
export default function ArticleContent({ article }: Props) {

    const baseMediaUrl = (import.meta.env.VITE_API_URL || 'https://localhost') + '/uploads/';
    const displayName = article.author.nomUsage ? `${article.author.prenom} ${article.author.nomUsage}` : `${article.author.prenom} ${article.author.nomNaissance}`;

    const htmlTypes: BlockType[] = ["text", "info", "exercice", "glossary"];
    const typeComponents: { [key in BlockType]?: (content: string, media: Media) => ReactNode } = {
        "info": (text: string) => <ColouredText text={text} color="blue" />,
        "glossary": (text: string) => <ColouredText text={text} color="green" />,
        "exercice": (text: string) => <ColouredText text={text} color="purple" />,
        "image": (text: string, media: Media) => <ImageBlock url={baseMediaUrl + media.url} alt={text} />,
    };

    return <div className="flex flex-col gap-4 p-4 rounded-lg bg-white border border-gray-200 drop-shadow-xl">
        <h2 className="text-4xl font-bold text-center">{article.title}</h2>
        <div className="flex flex-col gap-2 ">
            {article.sections.map((section, index) => (
                <div key={index}>
                    <h3 className="text-xl font-semibold">{section.title}</h3>
                    {section.blocks.map((block, bIndex) => {
                        if (typeComponents[block.type]) {
                            return (
                                <Fragment key={bIndex}>
                                    {typeComponents[block.type]!(block.content, block.media)}
                                </Fragment>
                            );
                        }
                        return (
                            <div key={bIndex} className="mt-2">
                                {htmlTypes.includes(block.type) && <div dangerouslySetInnerHTML={{ __html: block.content }} />}
                                {block.type === "image" && <img src={baseMediaUrl + block.media.url} alt={`Block ${bIndex} image`} />}
                                {/* Add more block type renderings as needed */}
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
        <div className='flex gap-2 items-center text-sm text-gray-500'>
            {article.author.avatar?.url && <img src={article.author.avatar ? baseMediaUrl + article.author.avatar.url : '/default-avatar.png'} alt="Author Avatar" className="w-16 h-16 rounded-full object-cover" />}
            <p>écrit par {displayName} le {new Date(article.createdAt).toLocaleDateString()}</p>
        </div>
    </div>;
}